import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import QuestionCategory from './question_category';
import Scrollbars from 'react-custom-scrollbars';
import MsxIcons from '../features/msx-icons';
import I10n from '../features/i10n';
import FilterHead from './question_list_filter_header';


const ScrollbarsWrapper = styled.div`
  flex: 1 1 0px;
  display: flex;
  position: relative;
`;

const CategoryWrapper = styled.div`
  border-radius: 8px;
  margin-bottom: 50px;
  position: relative;
`;

const ClearFilterButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  background-color: white;
  color: #42B4E6;
  padding-left: 5px;
  font-size: 14px;
  min-height: 25px;
  padding: 0px 10px;
  border: 1px solid #42B4E6;
  margin-top: 10px;
  margin-bottom: 5px;
  width: 80%; 
  margin-left: auto;
  margin-right: auto;
`;

const ClearFilterIcon = styled.div`
margin-right: 10px;
`;

const Test = styled.div`
  display: flex;
  flex: 1 1 0px;
`;

const FilterHeadWrapper = styled.div`
  display: flex;
  flex-grow: 0;
  flex-shrink: 1;
  flex-basis: auto;
`;

const FilerContentWrapper = styled.div`
border-radius: 10px;
border: 1px solid #E6E6E6;
background-color: white;
`

class FilterContent extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      isFilterOpen: props.isFilterOpen || false,
    };
    this.renderCategories = this.renderCategories.bind(this);
    this.toggleFilter = this.toggleFilter.bind(this);

  }

  static propTypes = {
    aggregatedQuestions: PropTypes.array,
    isLoading: PropTypes.bool,
    onAnswerChanged: PropTypes.func,
    onResetQuestionAnswers: PropTypes.func,
    questionsWithAnswers: PropTypes.object,
    questionMap: PropTypes.object,
    remainingOptions: PropTypes.object,
    sharedOptions: PropTypes.object,
    baseOptions: PropTypes.object,
    resultsLoading: PropTypes.bool,
    mobileFilterOpened: PropTypes.bool,
    toggleMobileFilter: PropTypes.func,
    openModal: PropTypes.func,
    isFilterOpen: PropTypes.bool,
  }

  toggleFilter = () => {
    this.setState(prevState => ({
      isFilterOpen: !prevState.isFilterOpen
    }))
  }

  setWrapperRef = element => {
    this.wrapperElement = element;
  };

  get numberQuestionsAnswered() {
    return Object.keys(this.props.questionsWithAnswers).length;
  }

  get haveQuestionsAnswered() {
    return !!Object.keys(this.props.questionsWithAnswers).length;
  }

  clearEmptyAnswer = () => {
    const newQuestionsWithAnswer = this.props.questionsWithAnswers;
    const keys = Object.keys(newQuestionsWithAnswer);
    for (let i = 0; i < keys.length; i++) {
      if (newQuestionsWithAnswer[keys[i]].length === 0) {
        delete newQuestionsWithAnswer[keys[i]];
      }
    }

    return newQuestionsWithAnswer;
  }

  get totalQuestionsAnswered() {
    let total = 0;
    this.props.aggregatedQuestions.forEach((questionCategory) => {
      questionCategory.questions.forEach((question) => {
        if (this.props.questionsWithAnswers[question.questionKey] != null) {
          total++;
        }
      });
    });
    return total;
  }

  /**
   * Removes all questions with answer which depends of the question that was updated.
   * @param {*} questionKey The question key of the question where answer was updated
   */
  removeAnswerFromQuestionDependingFromQuestionKey(questionKey) {
    const newQuestionsWithAnswer = this.props.questionsWithAnswers;
    const keysOfQuestionsToRemove = [questionKey];
    // Remove all the dependency tree with a stack
    while (keysOfQuestionsToRemove.length > 0) {
      const currentKey = keysOfQuestionsToRemove.pop();
      // Check if there is a question which depends from the current question key.
      for (const key of Object.keys(this.props.questionsWithAnswers)) {
        const question = this.props.questionMap[key];
        // If found, push it and delete the answer to delete questions which also depends
        // from this one.
        if (question?.previousQuestionKey === currentKey) {
          keysOfQuestionsToRemove.push(question.questionKey);
          delete newQuestionsWithAnswer[question.questionKey];
        }
      }
    }
    return newQuestionsWithAnswer;
  }

  onAnswerChanged = (question, value, status) => {
    let newQuestionsWithAnswer = this.props.questionsWithAnswers;
    if (status === 'remove') {
      newQuestionsWithAnswer[question.questionKey] = newQuestionsWithAnswer[question.questionKey].filter(e => e !== value);
      newQuestionsWithAnswer = this.clearEmptyAnswer();
    } else {
      if (newQuestionsWithAnswer[question.questionKey]) {
        newQuestionsWithAnswer[question.questionKey].push(value);
      } else {
        newQuestionsWithAnswer[question.questionKey] = [value];
      }
    }

    this.props.onAnswerChanged
      (this.removeAnswerFromQuestionDependingFromQuestionKey(question.questionKey));
  }

  renderCategories = () => {   
    return this.props.aggregatedQuestions
      .map((questionCategory, index) => {
        return (
          <QuestionCategory key={index}
            questionCategory={questionCategory}
            onAnswerChanged={this.onAnswerChanged}
            questionsWithAnswers={this.props.questionsWithAnswers}
            questionMap={this.props.questionMap}
            shouldBeOpened={index === 0}
            onOpenStateChange={() => { this.forceUpdate(); }}
            remainingOptions={this.props.remainingOptions}
            sharedOptions={this.props.sharedOptions}
            baseOptions={this.props.baseOptions}
            resultsLoading={this.props.resultsLoading}
            openModal={this.props.openModal}
            scrollbarWrapper={this.wrapperElement}
          >
          </QuestionCategory>
        );
      });
  }  



  render() {
    return (
      <Test id='FilterContent 0' isFilterOpen={this.isFilterOpen}>
        <ScrollbarsWrapper id='FilterContent 1' ref={this.setWrapperRef}>

          <Scrollbars id='FilterContent 2'>
          <FilerContentWrapper>
          <FilterHeadWrapper onClick={() => this.setState(prevState => ({ isFilterOpen: !prevState.isFilterOpen }))}>
          <FilterHead
            isLoading={this.props.isLoading}
            toggleFilter={this.props.toggleFilter}
            numberQuestionsAnswered={this.numberQuestionsAnswered}
            isFilterOpen={this.props.isFilterOpen}
          />

            </FilterHeadWrapper>

              
            <CategoryWrapper id='FilterContent 3'>
          
              { this.haveQuestionsAnswered && (
                <ClearFilterButton onClick={(e) => {
                  e.preventDefault();
                  this.props.resetQuestionAnswers();
                }}>
                  <ClearFilterIcon>
                    <MsxIcons name="delete" size="small"></MsxIcons>
                  </ClearFilterIcon>
                  {I10n.get(`screen.head_device_selector_screen.plc.answers_reset_hover`)}
                </ClearFilterButton>
              )}
              {this.renderCategories()}
            </CategoryWrapper>
            </FilerContentWrapper>
            
          </Scrollbars>
        </ScrollbarsWrapper>
      </Test>
    );
  }
  
}

export default FilterContent;